<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="600"
  >
    <v-card>
      <v-card-text>
        <v-form
          ref="formEntidadTecnicaPorExcel"
          lazy-validation
          @submit.prevent="save()"
        >
          <v-card-title class="pa-2">
            Crear convocatorias
            <v-spacer />
          </v-card-title>

          <div>
            <v-file-input
              id="file"
              placeholder="Sube tu archivo"
              label="File input"
              :loading="loadingJSon"
              :rules="[v => !!v || 'El teléfono personal es obligatorio']"
              :error-messages="fileExcel"
              @change="previewFiles"
            />
            <v-divider />
          </div>

          <template>
            <v-progress-linear
              v-if="isLoadinguploadFile"
              v-model="progressUploadFile"
              value="15"
              height="25"
            >
              <span
                color="white"
              >
                {{ progressUploadFile.toFixed(0) }} %
              </span>
            </v-progress-linear>
          </template>

          <v-card-actions class="pa-2">
            <v-btn
              outlined
              @click="close"
            >
              Cancelar
            </v-btn>
            <a
              class="px-2 py-1" 
              href="https://firebasestorage.googleapis.com/v0/b/proyectouno-719dd.appspot.com/o/Formato%20de%20convocatoria.xlsx?alt=media&token=d8edb46e-82b2-43cf-b093-424c3b7cbdd9"
              outlined
            >
              Descargar Formato
            </a>
            <v-spacer />
            <v-btn
              color="primary"
              type="submit"
              :loading="loading"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  // import firebase from 'firebase'
  import XLSX from 'xlsx'
  // const db = firebase.firestore()

  export default {
    data () {
      return {
        dialog: false,
        loading: false,
        fileExcel: '',
        progressUploadFile: 0,
        isLoadinguploadFile: false,
        objetodeCantidadModulos: [],
        convocatoriasExce: [],
        existeEntidadTecnica: [],
        existeFlat: false,
        loadingJSon: false,
        data_excel: [],
        HeadObject: [],
      }
    },
    methods: {
      open () {
        this.dialog = true
      },
      close () {
        this.dialog = false
        this.loading = false
        this.$refs.formEntidadTecnicaPorExcel.reset()
      },
      async save () {
        if (this.$refs.formEntidadTecnicaPorExcel.validate()) {
          this.loading = true
          await this.uploadExcel()
        }
      },
      async uploadExcel () {
        var myHeaders = new Headers()
        myHeaders.append('Content-Type', 'application/json')

        var raw = JSON.stringify({
          data: [
            ...this.data_excel
          ],
          head: [
            ...this.HeadObject[0]
          ]
        })

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow'
        }

        const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/convocatoria/excel', requestOptions)
        const data = await response.json()
        if (data.success) {}

        this.$emit('onUploadExcel')
        this.close()
        this.isLoadinguploadFile = false
         //CONSULTAR SI LA ENTIDAD EXISTE
        // await db.collection('EntidadesTecnicas').get().then(entidades => {
        // entidades.forEach(proyecto => {
        //     this.existeEntidadTecnica.push(proyecto.data())
        //   })
        // })
        // this.isLoadinguploadFile = true
        // var fileNameStorage = Math.random(30) + '.xlsx'
        // var ref = firebase.storage().ref('archivos').child(fileNameStorage)
        // var file = document.getElementById('file').files[0]
        // var uploadTask = ref.put(file)
        // uploadTask.on('state_changed', function (snapshot) {
        //   switch (snapshot.state) {
        //     case firebase.storage.TaskState.PAUSED:
        //       break
        //     case firebase.storage.TaskState.RUNNING:
        //       break
        //   }
        // }, function () {
        // }, function () {
        // })
        // var reader = new FileReader()
        // if (file?.name.split('.').pop() === 'xlsx' || file?.name.split('.').pop() === 'xls') {
        //   reader.onload = e => {
        //     var data = new Uint8Array(e.target.result)
        //     var XLSX = require('xlsx')
        //     var workbook = XLSX.read(data, { type: 'array' })
        //     const sheetName = workbook.SheetNames[0]
        //     const worksheet = workbook.Sheets[sheetName]
        //     if (sheetName === 'Hoja1') {
        //       //Crear convocatorias
        //       this.items = XLSX.utils.sheet_to_json(worksheet, { header: 1 })
        //       // const tamanodeConvocatorias = this.items[0].length
        //       for (let i = 2; i < this.items[0].length; i++) {
        //         this.objetodeCantidadModulos.push(
        //           { 
        //             nombre: this.items[0][i], 
        //             modulos: 0, 
        //             entidades: 0 
        //           })

        //         db.collection('Convocatorias').doc(this.items[0][i]).set({
        //           id: this.items[0][i],
        //           nombre: this.items[0][i],
        //           })
        //       }

        //       // Crear entidades Tecnicas

        //       this.items = XLSX.utils.sheet_to_json(worksheet)

        //       var length = this.items.length
        //       var i = 0
              
        //       this.items.forEach(async (item) => {
        //           const convocatoriasExcel = Object.keys(item)
        //           convocatoriasExcel.shift()
        //           const cantidadDeMOdulosExcelPorFila = Object.values(item)
        //           cantidadDeMOdulosExcelPorFila.shift()

        //           const docId = item.RUC.toString().trim()

        //           var existeEntidad = await this.existeEntidadTecnica.filter(e => e.id === docId)
        //         if (docId) {
        //           if (existeEntidad.length === 0) {
        //           // if (this.existeEntidadTecnica.filter(e => e.id === docId)) {
  
        //             //CREAR ENTIDAD TECNICA CON DATOS VACIO
        //             db.collection('EntidadesTecnicas').doc(docId).set({
        //               id: docId || '',
        //               ruc: item.RUC || '',
        //               convocatorias: [...convocatoriasExcel],
        //               cantidadDeModulos: [...cantidadDeMOdulosExcelPorFila],
        //               // razonSocial: item['ENTIDAD TECNICA'] ? item['ENTIDAD TECNICA'] : '',
  
        //               userId: JSON.parse(localStorage.userAuth).uid ? JSON.parse(localStorage.userAuth).uid : '',
        //             }, { merge: true }).then(result => {
        //               this.progressUploadFile = (i / length) * 100
        //               i++
        //               if (i === length) {
        //                 this.$emit('onUploadExcel')
        //                 this.close()
        //                 this.isLoadinguploadFile = false
        //               }
        //             })
        //           } else {
        //             //Modificar entidad tecnica existente
        //             db.collection('EntidadesTecnicas').doc(docId).set({
        //               id: docId || '',
        //               convocatorias: [...convocatoriasExcel],
        //               cantidadDeModulos: [...cantidadDeMOdulosExcelPorFila],
        //               // razonSocial: item['ENTIDAD TECNICA'] ? item['ENTIDAD TECNICA'] : '',
        //               direccionFiscalGPS: {
        //               Latitude: '',
        //               Longitude: '', 
        //               },
        //               direccionRealGPS: {
        //               Latitude: '',
        //               Longitude: '', 
        //               },
  
        //               userId: JSON.parse(localStorage.userAuth).uid ? JSON.parse(localStorage.userAuth).uid : '',
        //             }, { merge: true }).then(result => {
        //               this.progressUploadFile = (i / length) * 100
        //               i++
        //               if (i === length) {
        //                 this.$emit('onUploadExcel')
        //                 this.close()
        //                 this.isLoadinguploadFile = false
        //               }
        //             })
        //           }
        //         } else {
        //           this.progressUploadFile = (i / length) * 100
        //           i++
        //           if (i === length) {
        //             this.$emit('onUploadExcel')
        //             this.close()
        //             this.isLoadinguploadFile = false
        //           }
        //         }
        //       })
        //     } else {
        //       alert('Errror en excel, no se econtro la hoja excel llamada Hoja1')
        //       this.isValid_file = false
        //       this.close()
        //       this.isLoadinguploadFile = false
        //     }
        //   }
        //   reader.readAsArrayBuffer(file)
        // } else {
        //   this.isValid_file = true
        //   this.error_file = 'Este archivo no es un Excel.'
        // }
      },
      previewFiles (e) {
        // // this.fileUploading = true
        // var file = e
        // var reader = new FileReader()
        // if (file?.name.split('.').pop() === 'xlsx' || file?.name.split('.').pop() === 'xls') {
        //   this.fileExcel = ''
        //   reader.onload = e => {
        //     // this.fileUploading = false
        //     var data = new Uint8Array(e.target.result)
        //     var XLSX = require('xlsx')
        //     var workbook = XLSX.read(data, { type: 'array' })
        //     const sheetName = workbook.SheetNames[0]
        //     if (sheetName !== 'Data') {
        //       this.isValid_file = false
        //       this.fileExcel = 'Este archivo Excel es incorrecto.'
        //     } else {
        //       this.isValid_file = true
        //       this.fileExcel = ''
        //     }
        //   }
        // } else {
        //   // this.isValid_file = true
        //   this.fileExcel = 'Este archivo no es un Excel.'
        // }
        this.loadingJSon = true

        const file = document.getElementById('file').files[0]
        if (file) {
            const fileReader = new FileReader()
            fileReader.readAsBinaryString(file)
            fileReader.onload = (event) => {
              const data = event.target.result
              const workbook = XLSX.read(data, { type: 'binary' })
              workbook.SheetNames.forEach(async sheet => {
                  const rowObject = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet])
                  const HeadObject = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet], { header: 1 })
                  this.data_excel = rowObject
                  this.HeadObject = HeadObject
                  // await this.sendData()
                  })
            }
        }
        this.loadingJSon = false
      },
      descargarFormato () {
      }
    },

  }
</script>

<style>

</style>
